export const guestScenariosStorageKey = "guestScenarios" as const;
